import { useEffect } from "react";

interface IProps {
  func: () => void;
  modifierKey?: boolean;
  keyboardKey: KeyboardEvent["key"];
}

const useKeyboardShortcut = ({
  func,
  modifierKey,
  keyboardKey: keyboardKey,
}: IProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        (event.metaKey || event.ctrlKey || !modifierKey) &&
        event.key === keyboardKey
      )
        func();
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [func, keyboardKey, modifierKey]);
};

export default useKeyboardShortcut;
